import { filterQuotesByExcess } from '@/src/utils/filterQuotesByExcess';
import { useBoilerQuote } from './useBoilerQuote';
import {
  ExcessAmountValue,
  IQuote,
  ProductCode,
} from '@/src/api/homeServices/types';

export type OfferType = 'duration' | 'discount';
export const useHomeplanOffer = ({ needsRepair } = { needsRepair: false }) => {
  const { data, isError, isLoading } = useBoilerQuote(needsRepair);
  const quotesWrappers = data?.result;
  const quotes = quotesWrappers?.flatMap(quotesWrapper => quotesWrapper.quotes);
  const quotesExcludeHighExcess =
    quotes &&
    filterQuotesByExcess(quotes, [
      ExcessAmountValue.ZERO,
      ExcessAmountValue.SIXTY,
    ]);
  const higestPromotionDurationQuote = quotesExcludeHighExcess?.reduce(
    (highestDurationQuote, quote) => {
      if (!highestDurationQuote) {
        return quote;
      }
      return highestDurationQuote.price?.promotion?.duration >
        quote?.price?.promotion?.duration && quote?.offer
        ? highestDurationQuote
        : quote;
    },
  );

  const completeQuote = quotesExcludeHighExcess?.find(
    quote =>
      quote.product === ProductCode.COMPLETE ||
      quote.product === ProductCode.HOME_RECOVER_COMPLETE,
  );

  const completeQuotes = quotesExcludeHighExcess?.filter(
    quote =>
      quote.product === ProductCode.COMPLETE ||
      quote.product === ProductCode.HOME_RECOVER_COMPLETE,
  );

  const completeQuoteWithExcess = completeQuotes?.find(
    quote => quote.excess === ExcessAmountValue.SIXTY,
  );

  const completeQuoteWithoutExcess = completeQuotes?.find(
    quote => quote.excess === ExcessAmountValue.ZERO,
  );

  const getDiscountPercentage = (quote?: IQuote) => {
    if (quote?.price.discount.monthly && quote?.price.standard.monthly) {
      const discountPercentage =
        (quote?.price?.discount?.monthly / quote?.price?.standard.monthly) *
        100;
      return discountPercentage;
    }
  };
  const isOfferAvailable = higestPromotionDurationQuote?.offer;
  const promoEndDate = higestPromotionDurationQuote?.offer?.enddate;
  const isTieredOfferDuration =
    quotesExcludeHighExcess &&
    !Object.values(quotesExcludeHighExcess).every(
      quote =>
        quote?.price?.promotion?.duration ==
        quotesExcludeHighExcess?.[0].price?.promotion?.duration,
    );

  const isTieredOfferDiscount =
    quotesExcludeHighExcess &&
    !Object.values(quotesExcludeHighExcess).every(quote => {
      const completeQuoteDiscount = getDiscountPercentage(completeQuote);
      const quoteDiscount = getDiscountPercentage(quote);
      return (
        completeQuoteDiscount &&
        quoteDiscount &&
        completeQuoteDiscount === quoteDiscount
      );
    });
  const promotionDuration = isOfferAvailable
    ? higestPromotionDurationQuote?.price?.promotion?.duration
    : 0;

  /* 
    Home services normally offers 2 different types of promotion, 
    */
  const offerType: OfferType =
    promotionDuration == 12 ? 'discount' : 'duration';

  return {
    promotionDuration,
    isError,
    isLoading,
    promoEndDate,
    isTieredOfferDuration,
    isTieredOfferDiscount,
    isOfferAvailable,
    offerType,
    completeQuoteWithoutExcess,
    completeQuoteWithExcess,
    maxDiscountPercentage: getDiscountPercentage(completeQuoteWithoutExcess),
  };
};
